<div class="collapsible-header">
  <h6
    (click)="toggleCollapsible()"> <b>{{ headerTitle }} </b><i class="fas" [ngClass]="{'fa-caret-down': !isCollapsed, 'fa-caret-up': isCollapsed}"></i></h6>
  <div class="additional-info" [hidden]="isCollapsed">
    <!-- Additional information goes here -->
    <p [innerHTML]="additionalInfo"></p>
<!--    <p>{{ additionalInfo }}</p>-->
  </div>
</div>
